module.exports = __webpack_public_path__ + "media/images/misc/border-v-ef12a3808ff50e053017d2c87e633ca1584966be309eb225364e647bce91a11d.gif";